var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12L17.15 18.15C16.9667 18.4167 16.7292 18.625 16.4375 18.775C16.1458 18.925 15.8333 19 15.5 19H5.5C4.95 19 4.47917 18.8042 4.0875 18.4125C3.69583 18.0208 3.5 17.55 3.5 17V7C3.5 6.45 3.69583 5.97917 4.0875 5.5875C4.47917 5.19583 4.95 5 5.5 5H15.5C15.8333 5 16.1458 5.075 16.4375 5.225C16.7292 5.375 16.9667 5.58333 17.15 5.85L21.5 12Z",
    fill: "#0BA9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignTags);
export default __webpack_public_path__ + "static/media/assign-tags.4abfee2bcac2a695a2d27d71d75ac52f.svg";
export { ForwardRef as ReactComponent };